export function detectDevice() {
  const ua = navigator.userAgent.toLowerCase();

  const isMobile =
    /iphone|ipod|android.*mobile|windows phone|blackberry|iemobile|opera mini/.test(
      ua
    );
  const isTablet = /ipad|android(?!.*mobile)|tablet/.test(ua);
  const isDesktop = !isMobile && !isTablet;

  const isIOS = /iphone|ipad|ipod/.test(ua);
  const isAndroid = /android/.test(ua);
  const isSafari = /safari/.test(ua) && !/chrome/.test(ua);
  const isChrome = /chrome|crios/.test(ua);
  const isEdge = /edg/.test(ua);
  const isFirefox = /firefox/.test(ua);
  const isSamsungBrowser = /samsungbrowser/.test(ua);

  return {
    device: isMobile ? "mobile" : isTablet ? "tablet" : "desktop",
    os: isIOS ? "iOS" : isAndroid ? "Android" : "Other",
    browser: isSamsungBrowser
      ? "Samsung Internet"
      : isChrome
      ? "Chrome"
      : isSafari
      ? "Safari"
      : isEdge
      ? "Edge"
      : isFirefox
      ? "Firefox"
      : "Other",
    isMobile,
    isTablet,
    isDesktop,
    isIOS,
    isAndroid,
  };
}

export function isMobile() {
  return detectDevice().isMobile;
}

export function isDesktop() {
  return detectDevice().isDesktop;
}
